import { addDoc, collection, doc, getDoc, setDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

const VISITOR_KEY = "integrated_visitor_id";

function makeId() {
  return "visitor_" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
}

export function getVisitorId() {
  if (typeof window === "undefined") return null;
  let id = window.localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = makeId();
    window.localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export async function trackVisitor(route = "Home") {
  try {
    const visitorId = getVisitorId();
    if (!visitorId) return;
    const visitorRef = doc(db, "visitors", visitorId);
    const snapshot = await getDoc(visitorRef);

    const visitorData = {
      visitorId,
      route,
      lastSeen: serverTimestamp(),
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "unknown",
    };

    if (snapshot.exists()) {
      await updateDoc(visitorRef, visitorData);
    } else {
      await setDoc(visitorRef, {
        ...visitorData,
        firstSeen: serverTimestamp(),
      });
    }
  } catch (error) {
    // ignore tracking errors
  }
}

export async function trackPageView(page = "Home") {
  try {
    const visitorId = getVisitorId();
    await addDoc(collection(db, "pageViews"), {
      visitorId,
      page,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    // ignore tracking errors
  }
}

export async function trackServiceView(service = "Unknown") {
  try {
    const visitorId = getVisitorId();
    await addDoc(collection(db, "serviceViews"), {
      visitorId,
      service,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    // ignore tracking errors
  }
}
